import React from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import Index from "./index";

export default function EnquiriesTable({ heading, enquiries, loading, search, setSearch, onDelete }) {
    const { history } = Index();

    const actions = (d) => {
        return (
            <div className="flex justify-content-around gap-1">
                <i className="pi pi-eye cursor-pointer" onClick={() => history.push(`enquiries/view/${d._id}`)}></i>
                <i className="pi pi-trash cursor-pointer" onClick={(e) => onDelete(e, d._id)}></i>
            </div>
        );
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    return (
        <>
            <TableCard title={heading} onSearch={setSearch} searchKeyword={search}>
                <DataTable
                    paginator
                    value={enquiries}
                    selectionMode="checkbox"
                    showGridlines
                    filter={filters}
                    filterDisplay="menu"
                    rows={10}
                    loading={loading}
                    emptyMessage="No order found."
                >
                    <Column header="Full Name" field="fullName"></Column>
                    <Column header="Email" field="email"></Column>
                    <Column header="Phone Number" field="phoneNumber"></Column>
                    <Column header="Service Question" field="serviceQuestion"></Column>
                    <Column header="Created At" field="time" body={(r) => formatDate(r.time)} ></Column>
                    <Column body={actions} style={{ width: "100px" }} header="Action"></Column>
                </DataTable>
            </TableCard>
        </>
    );
}
